import { useState, useEffect } from 'react';
import BasicFormStepByStep from '../../../Components/Generic/basicFormStepByStep';
import useGlobalContext from '../../../Hooks/useGlobalContext';
import modelSelection from '../../../Helpers/modelSelection';
import { VALIDATIONS_COMPANIES } from '../../../constants/paths';

function CompanyViews({companyId, closeDialog}) {
  const globalContext = useGlobalContext();

  const [fields, setFields] = useState([]);
  const [form, setForm] = useState(null);
  const [prevBind, setPrevBind] = useState({});
  const [firstBindEdit, setFirstBindEdit] = useState({});
  const [activePrevBind] = useState(true);
  const [mode] = useState('view');

  useEffect(() => {
    const { suplychain, l1, rol } = firstBindEdit;
    setPrevBind(firstBindEdit);
    setModels(suplychain, l1, rol);
  }, [firstBindEdit]);

  const setModels = (cadenas, pais, roles) => {
    let models = globalContext.getSessionDataByKey('models');
    let attributesModel = [];
    let activeModel = {};

    let modelKeyCountry = 'DEFAULT';
    let modelLabels = 'DEFAULT';
    let modelKeyChain = '';
    let modelKeyRol = '';

    activeModel = models['companyModels']['basic']['companyTypes']['DEFAULT'];

    if (pais) {
      modelKeyCountry = models['companyModels']['basic']['companyTypes'][pais]
        ? pais
        : 'AR';
      modelLabels = models['companyModels']['basic']['fieldsLabels'][pais]
        ? pais
        : 'DEFAULT';
    }

    if (cadenas && roles) {
      let model = [];

      const chainSort = cadenas.split(',');
      chainSort.sort((a, b) => b - a);

      const rolSort = roles.split(',');
      rolSort.sort((a, b) => b - a);

      model = models['companyModels']['basic']['companyTypes'][modelKeyCountry];
      modelKeyChain = modelSelection(model, chainSort);

      if (
        models['companyModels']['basic']['companyTypes'][modelKeyCountry][
          modelKeyChain
        ]
      ) {
        model =
          models['companyModels']['basic']['companyTypes'][modelKeyCountry][
            modelKeyChain
          ];
        modelKeyRol = modelSelection(model, rolSort);
      }

      if (modelKeyChain && modelKeyRol) {
        //Json parse y stringify para eliminar toda referencias
        activeModel = JSON.parse(
          JSON.stringify(
            models['companyModels']['basic']['companyTypes'][modelKeyCountry][
              modelKeyChain
            ][modelKeyRol]
          )
        );
        activeModel.form.configEdit &&
          activeModel.form.config.push(...activeModel.form.configEdit);
      }
    }

    for (const step of activeModel.form.config) {
      for (const section of step.sections) {
        for (const field of section.fields) {
          const attribute = models['companyModels']['basic'].attributes
            .filter((atrr) => atrr.name === field)
            .map((attr) => ({ ...attr }));
          if (attribute[0].name === 'l1') {
            attribute[0].disabled = true;
          }

          attribute && attributesModel.push(...attribute);
        }
      }
    }

    if (models['companyModels']['basic']['fieldsLabels'][modelLabels]) {
      for (const objLabels of models['companyModels']['basic']['fieldsLabels'][
        modelLabels
      ]) {
        const matchingAttribute = attributesModel.find(
          (atrr) => atrr.name === objLabels.name
        );
        matchingAttribute && (matchingAttribute.label = objLabels.label);
      }
    }

    const filteredAttributesModel = attributesModel.filter((attr) => attr.name !== 'suplychain' && attr.name !== 'rol' && attr.name !== 'l1' && attr.name !== 'certificates');
    
    setFields(
      filteredAttributesModel && filteredAttributesModel.length > 0
        ? filteredAttributesModel
        : attributesModel
    );

    const customForm = {
      render: true,
      stepValidation: true,
      config: [
        {
          step: 1,
          title: '-',
          sections: [
            {
              section: 1,
              title: '-',
              fields: filteredAttributesModel.map((attr) => attr.name),
            },
          ],
        },
      ],
    };
    setForm(customForm);
  };

  return (
    <BasicFormStepByStep
      formMode={'vertical'}
      show={true}
      noSteps={true}
      showStepTitle={false}
      showSectionTitle={false}
      showCancelButton={true}
      cancelButtontext={'miscellaneous.close'}
      onCanceled={() => { closeDialog && closeDialog() }}
      sectionAccordionMode={false}
      redirectOnErrorPath={VALIDATIONS_COMPANIES}
      autocompleteSandboxMode={false}
      fieldColSize={12}
      activePrevBind={activePrevBind}
      firstBindEdit={firstBindEdit}
      setFirstBindEdit={setFirstBindEdit}
      prevBind={prevBind}
      withDefault={false}
      mode={mode}
      pk={companyId}
      pkReferer={null}
      bindNullWithDefault={true}
      objectType={'company'}
      objectTypeBindForm={'company'}
      parentType={'root'}
      parentTypeSubType={1}
      count={0}
      fields={fields}
      form={form}
    />
  );
}

export default CompanyViews;
